import { useState, useMemo } from 'react';
import { LoadingSpinner } from '../../common/components/LoadingSpinner';
import { ErrorsType } from '../../common/constants/commonConstants';
import { buildAlertWithContactSupport } from '../../common/utils/alerts';
import { errorLabels } from '../../common/utils/errorUtils';
import { INTEGRATION_STATUS } from '../constants';
import { useAppStatus } from '../hooks/useAppStatus';
import { getAppStatusByWebinarSource } from '../utils/webinarFormUtils';
import IntegrationSelection from './IntegrationSelection';
import WebinarSelectionForm from './WebinarSelectionForm';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import LabelWithTooltip from '../../common/components/LabelWithTooltip';
import { isUngatedGoToWebinarComponentMigration } from '../../common/Gate';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormLabelWithTooltip = ({
  labelI18n,
  appName
}) => /*#__PURE__*/_jsx(FormLabel, {
  paddingBlockEnd: "100",
  children: /*#__PURE__*/_jsx(LabelWithTooltip, {
    labelText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `videoConference.settings.webinarsForm.${labelI18n}.label`,
      options: {
        appName
      }
    }),
    tooltipText: I18n.text(`videoConference.settings.webinarsForm.${labelI18n}.tooltipMessage`)
  })
});

// This component is only needed for gate, after deleting gate this component can be removed by moving all logic to WebinarSelection
const WebinarSelectionContainer = props => {
  const {
    isLoadingAppStatus,
    appStatusError,
    appStatusData = []
  } = useAppStatus();
  const [webinarSource, setWebinarSource] = useState(props.webinarSource);
  const filteredAppStatusData = useMemo(() => {
    const filteredStatusForGoToWebinar = (filteredStatus, currentStatus) => {
      const {
        appId
      } = currentStatus;
      if ((appId === 1158066 || appId === 35161) && !isUngatedGoToWebinarComponentMigration(props.gates)) {
        return filteredStatus;
      }
      filteredStatus.push(currentStatus);
      return filteredStatus;
    };
    return appStatusData ? appStatusData.filter(({
      appStatus
    }) => appStatus !== INTEGRATION_STATUS.DISCONNECTED).reduce(filteredStatusForGoToWebinar, []) // This is only needed for GoToWebinar, once they have all customers ungated it will need to be removed.
    : [];
  }, [appStatusData, props.gates]);
  const currentIntegrationData = useMemo(() => getAppStatusByWebinarSource(webinarSource, filteredAppStatusData), [filteredAppStatusData, webinarSource]);
  const onWebinarSource = ({
    target: {
      value
    }
  }) => {
    setWebinarSource(value);
  };
  if (isLoadingAppStatus) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  if (appStatusError) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormLabelWithTooltip, {
        labelI18n: "header"
      }), buildAlertWithContactSupport(errorLabels[ErrorsType.WEBINAR_FORMS_APP_STATUS_ERROR], {
        marginTop: '-15px'
      })]
    });
  }
  return filteredAppStatusData.length ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormLabelWithTooltip, {
      labelI18n: "header"
    }), /*#__PURE__*/_jsx(IntegrationSelection, {
      appStatusData: filteredAppStatusData,
      webinarSource: webinarSource,
      onWebinarSource: onWebinarSource
    }), currentIntegrationData ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormLabelWithTooltip, {
        labelI18n: "headerRegistration",
        appName: currentIntegrationData.appName
      }), /*#__PURE__*/_jsx(WebinarSelectionForm, Object.assign({}, props, currentIntegrationData, {
        webinarSource: webinarSource
      }))]
    }) : null]
  }) : null;
};
export default WebinarSelectionContainer;